import classNames from 'classnames';
import { getAssetUrl } from '../../../utils/config';
import { NotificationOptions } from '../../molecules/Notifications';
import './style.scss';

type NotificationProps = NotificationOptions & {
  onClose: (notificationId: string) => void;
  isRemoved?: boolean;
};

const Notification = (props: NotificationProps) => {
  const { id, level, text, closable, onClose, isRemoved } = props;
  return (
    <li
      className={classNames('notification', `notification--${level}`, { 'notification--remove': isRemoved })}
      key={id}
      id={id}
    >
      <img className="notification__icon-level" src={getAssetUrl(`notifications/${level}.svg`)} key="img-level" />
      <p className="notification__text">{text}</p>
      {closable && (
        <img
          className="notification__icon-close"
          src={getAssetUrl('notifications/close.svg')}
          key="img-close"
          onClick={() => onClose(id)}
        />
      )}
    </li>
  );
};
export default Notification;
